/* v2 entry point: install global styles, then let <g-shell> take over.

   Workspace elements are registered as a side effect of layout/routes.ts
   importing each one's WorkspaceDef, so there are no imports here beyond the
   shell itself.

   core/share is imported for its side effect and listed first for readability;
   the ordering is not load-bearing, because g-shell imports it too and a
   module's dependencies always evaluate before its body. See core/share.ts. */

import './core/share.js';
import { installGlobalStyles } from './design/base.js';
import { installServiceWorker } from './core/sw.js';
import './layout/g-shell/g-shell.js';

installGlobalStyles();
installServiceWorker();
